import React from 'react'
import { match } from 'ts-pattern'
import type { FindingSortField, SortOrder } from '../utils/api-client/api-schemas'
import { SortDropdownMenu, type SortDropdownMenuProps, type SortOption } from './menus/sort-dropdown-menu'

// Findings-specific sort options
const FINDINGS_SORT_OPTIONS: SortOption<FindingsSortValue>[] = [
  { value: 'pixee-intelligence', label: 'Pixee Intelligence' },
  { value: 'pixee-severity', label: 'Pixee Severity' },
  { value: 'tool-severity', label: 'Tool Severity' },
  { value: 'effective-cvss', label: 'CVSS' },
]

export type FindingsSortValue = 'pixee-intelligence' | 'pixee-severity' | 'tool-severity' | 'effective-cvss'

export type FindingsSortDropdownMenuProps = Pick<
  SortDropdownMenuProps<FindingsSortValue>,
  'onSortChange' | 'isAscending' | 'onSortDirectionChange' | 'className'
> & {
  selectedSort: FindingsSortValue
}

export const FindingsSortDropdownMenu: React.FC<FindingsSortDropdownMenuProps> = props => {
  return <SortDropdownMenu {...props} selectedValue={props.selectedSort} options={FINDINGS_SORT_OPTIONS} />
}

// Map frontend sort options to backend API values
export const mapSortOptionToApi = (sortOption: FindingsSortValue): FindingSortField => {
  return match(sortOption)
    .with('pixee-intelligence', (): FindingSortField => 'pixee-intelligence')
    .with('pixee-severity', (): FindingSortField => 'pixee-severity')
    .with('tool-severity', (): FindingSortField => 'severity')
    .with('effective-cvss', (): FindingSortField => 'effective-cvss')
    .exhaustive()
}

// Map frontend sort direction to backend API values
export const mapSortDirectionToApi = (isAscending: boolean): SortOrder => {
  return isAscending ? 'asc' : 'desc'
}
